import { httpRequest } from "../../http";

/** Every declared feature flag, by code, and whether it is on for the signed-in user (MPN-1963). */
export type FeatureFlags = Record<string, boolean>;

export class CommandListFeatureFlags {
  async run(): Promise<FeatureFlags> {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/feature-flags/`;

    try {
      const response = await httpRequest<unknown>(url, { method: "GET" });
      // Anything but a map of booleans says nothing about any flag, so every flag reads off.
      if (!response || typeof response !== "object" || Array.isArray(response)) return {};
      return Object.fromEntries(
        Object.entries(response).filter(([, on]) => typeof on === "boolean"),
      ) as FeatureFlags;
    } catch (error) {
      console.error("Error fetching feature flags:", error);
      throw error;
    }
  }
}
